import { Fragment } from 'react'

import CardWrapper from 'Root/App/Card/Wrapper'

import Body from '../Body'
import CollectionContentHeader from '../Header'
import styles from './index.module.css'

const Container = ({
  children,
  content,
  collectionVisibility,
  collectionPreparatory,
  isCompleted,
}) => {
  return (
    <Fragment>
      <CollectionContentHeader content={content} />
      <Body
        content={content}
        isCompleted={isCompleted}
        collectionPreparatory={collectionPreparatory}
        collectionVisibility={collectionVisibility}
      >
        <CardWrapper id={content.id} className={styles.card}>
          {children}
        </CardWrapper>
      </Body>
    </Fragment>
  )
}

export default Container
